
export const UserBookNotice = ({children}) => {
    return (
        <div className="notice_wrap">
            <div className="in_notice_wrap">
                <div className="notice">
                    <img src={`${process.env.PUBLIC_URL}/static/images/userbook/userbook_notice_icon.png`} alt="공지사항" />
                    <div className="notice_icon">공지</div>
                    <p>반말, 욕설, 비방, 비속어, '과격한 언어'의 경우, <span>주의</span> 들어갑니다. </p>
                </div>
            </div>
        </div>
    );
};